// extracted by mini-css-extract-plugin
export default {"stripe_payment":"StripePayment_stripe_payment__RdYdG","card":"StripePayment_card__Y+XcI","card_element_box":"StripePayment_card_element_box__vIKTD","add":"StripePayment_add__5JSPd"};